import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';
import { useAuth } from '@/context/AuthContext';
import { Users, Calendar, DollarSign, MessageSquare, Award } from 'lucide-react';

export default function ParentPortal() {
  const { user } = useAuth();

  const children = [
    { name: 'Student Name', grade: 'Class 10', attendance: '92%', fees: '₹5,000 Due' }
  ];

  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-2">Welcome, {user?.displayName || 'Parent'}!</h1>
          <p className="text-blue-100">Parent Portal Dashboard</p>
        </div>
      </section>

      <section className="py-12 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-blue-900 mb-6">Your Children</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {[
              { icon: Users, label: 'Children', value: children.length, color: 'bg-blue-100 text-blue-700' },
              { icon: Calendar, label: 'Avg Attendance', value: '92%', color: 'bg-green-100 text-green-700' },
              { icon: Award, label: 'Performance', value: 'Excellent', color: 'bg-purple-100 text-purple-700' },
              { icon: DollarSign, label: 'Pending Fees', value: '₹5,000', color: 'bg-amber-100 text-amber-700' }
            ].map((stat, i) => (
              <GlassCard key={i} className="text-center">
                <div className={`w-16 h-16 ${stat.color} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                  <stat.icon className="w-8 h-8" />
                </div>
                <h3 className="text-3xl font-bold text-blue-900 mb-1">{stat.value}</h3>
                <p className="text-slate-600 font-medium">{stat.label}</p>
              </GlassCard>
            ))}
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            <div>
              <h2 className="text-2xl font-bold text-blue-900 mb-6">Student Details</h2>
              {children.map((child, i) => (
                <GlassCard key={i} className="mb-6">
                  <h3 className="text-xl font-bold text-blue-900 mb-4">{child.name}</h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm text-slate-600">Grade</p>
                      <p className="font-semibold text-blue-900">{child.grade}</p>
                    </div>
                    <div>
                      <p className="text-sm text-slate-600">Attendance</p>
                      <p className="font-semibold text-green-600">{child.attendance}</p>
                    </div>
                    <div>
                      <p className="text-sm text-slate-600">Fees Status</p>
                      <p className="font-semibold text-amber-600">{child.fees}</p>
                    </div>
                  </div>
                </GlassCard>
              ))}
            </div>

            <div>
              <h2 className="text-2xl font-bold text-blue-900 mb-6">Quick Actions</h2>
              <div className="space-y-4">
                {[
                  { icon: DollarSign, label: 'Pay Fees Online' },
                  { icon: MessageSquare, label: 'Message Teacher' },
                  { icon: Calendar, label: 'View Attendance' },
                  { icon: Award, label: 'View Report Cards' }
                ].map((action, i) => (
                  <GlassCard key={i} className="hover:shadow-xl transition-shadow cursor-pointer">
                    <div className="flex items-center space-x-3">
                      <action.icon className="w-6 h-6 text-blue-900" />
                      <span className="font-semibold text-blue-900">{action.label}</span>
                    </div>
                  </GlassCard>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
